import { Injectable } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireStorage } from '@angular/fire/storage';
@Injectable({
  providedIn: 'root',
})
export class DataService {
  constructor(
    private firestore: AngularFirestore,
    private firestorage: AngularFireStorage
  ) {}
  form = new FormGroup({
    Name: new FormControl(''),
    Address: new FormControl(''),
    Category: new FormControl(''),
    Description: new FormControl(''),
  });

  async createStore(data) {
    await this.firestore
      .collection('traffic')
      .add(data.traffic)
      .then(async (docReference) => {
        const promiseArray = [];

        promiseArray.push(
          this.firestorage.upload(
            `/Logos/${docReference.id}/storeimage.png`,
            data.logo
          )
        );

        promiseArray.push(
          this.firestore
            .collection('stores')
            .doc(docReference.id)
            .set({ ...data.data })
        );

        await Promise.all(promiseArray);
      });
  }
}
